import React from "react";
import type { CSSProperties } from "react";
import type { PostPreview } from "@/types";
import { Link } from "./link";
import { Image } from "./image";

type HomePostCardProps = {
  card: PostPreview;
  readMore: string;
  className?: string;
  style?: CSSProperties;
};

export const HomePostCard: React.FC<HomePostCardProps> = ({
  card,
  readMore,
  className,
  style,
}) => {
  // Match your existing routing shape
  const href = `/resources/${card.group}/${card.slug}`;

  // Title / image source as used in your PostCard
  const title = card.title || "Untitled";
  const imageSrc = card.coverImage; // same field your PostCard uses

  // Label + date formatting consistent with your PostCard
  const formatDate = (date: string) => {
    const d = new Date(date);
    if (isNaN(d.valueOf())) return "";
    const month = d.toLocaleString("default", { month: "long" });
    const day = d.getDate();
    return `${month} ${day}`;
  };

  const dateLabel = card.date ? formatDate(card.date) : "";

  return (
    <Link
      href={href}
      noStyle
      className={`postCard homePostCard ${className ? className : ""} postCard_light`}
      style={style}
    >
      <div className="homePostCard--media">
        {/* Use your custom Image component so images actually render */}
        <div className="postCard--imageWrapper">
          <Image
            src={imageSrc}
            alt={title || "Image"}
            width={1600}               // wider source; CSS controls height via aspect-ratio
            className="postCard--image homePostCard--img"
            // forceLarge
            format="webp"
            quality={85}
            // options={{ h: 1200, fit: "fill", focus: "faces" }}
            animateInView              // preserve your in-view fade/slide, if supported
          />
        </div>

        {/* Overlay: uses your existing postCard typography classes so fonts stay the same */}
        <div className="homePostCard--overlay">
          <div className="postCard--details">
            {card.label && <div className="postCard--tag">{card.label}</div>}
            {dateLabel && <div className="postCard--date">{dateLabel}</div>}
          </div>

          <h3 className="postCard--title">{title}</h3>

          <div className="postCard--readMore">{readMore}</div>
        </div>
      </div>
    </Link>
  );
};

export default HomePostCard;
